'use strict';

 /* @name thothApp.controller:ProductCatalogCtrl
 * @description
/**
 * @ngdoc function
 * # ProductCatalogCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProductCatalogCtrl', ['$scope', 'ProductCatalog', 'Pagination', function ($scope, ProductCatalog, Pagination) {

    $scope.products = {
      list: [],
      pager: {}
    };

    $scope.search = {
      'search': '',
      'by_column': '',
      'filters': {
        'name': 'fa-sort',
        'product_code': 'fa-sort-asc',
        'employees.name': 'fa-sort'
      }
    };

    $scope.getPage = function(page) {
      var params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      }
      ProductCatalog.index(params).then(function(response) {
        $scope.products.list = response.data.products;
        $scope.products.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      },function(error) {
        ProductCatalog.error(error);
      });
    };

    $scope.clearSearch = function() {
      $scope.search = {
        'search': '',
        'by_column': '',
        'filters': {
          'name': 'fa-sort',
          'product_code': 'fa-sort-asc',
          'employees.name': 'fa-sort'
        }
      }
      $scope.getPage(1);
    };

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.pager = {};
    $scope.getPage(1);

  }]);
